// Yerel saat (Türkiye UTC+3) bazlı tarih yardımcıları.
// `new Date().toISOString().split('T')[0]` UTC kullanır; gece 00:00-03:00 arasında
// "bugün" bir önceki günü verir. Takvim günü gereken her yerde bunları kullanın.

const pad = (n: number) => String(n).padStart(2, '0');

/** Verilen tarihin YEREL takvim gününü 'YYYY-MM-DD' olarak döndürür. */
export const toLocalDateString = (d: Date = new Date()): string =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

/** Bugünün yerel tarihi, 'YYYY-MM-DD'. */
export const todayLocal = (): string => toLocalDateString(new Date());

/** Bugünden `days` gün sonrasının (negatifse öncesinin) yerel tarihi. */
export const addDaysLocal = (days: number, from: Date = new Date()): string => {
  const d = new Date(from.getFullYear(), from.getMonth(), from.getDate() + days);
  return toLocalDateString(d);
};

/** Bu ayın ilk gününün yerel tarihi. */
export const monthStartLocal = (from: Date = new Date()): string =>
  toLocalDateString(new Date(from.getFullYear(), from.getMonth(), 1));

/**
 * 'YYYY-MM-DD' (veya ISO) bir tarihin takvim gününü yerel olarak döndürür.
 * Saat bilgisi olmayan değerleri UTC gece yarısı sanıp bir gün kaydırmaz.
 */
export const normalizeToLocalDate = (value: string): string => {
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : toLocalDateString(d);
};

/** İki 'YYYY-MM-DD' arasındaki takvim günü farkı (b - a). */
export const diffInDays = (a: string, b: string): number => {
  const [ay, am, ad] = a.split('-').map(Number);
  const [by, bm, bd] = b.split('-').map(Number);
  const ms = Date.UTC(by, bm - 1, bd) - Date.UTC(ay, am - 1, ad);
  return Math.round(ms / 86400000);
};

/** 'YYYY-MM-DD' bir tarihe `days` gün ekler (yerel takvim, saat dilimi kayması olmadan). */
export const addDaysToDate = (date: string, days: number): string => {
  const [y, m, d] = date.split('-').map(Number);
  return toLocalDateString(new Date(y, m - 1, d + days));
};
